import { SVGProps } from 'react';

export const SuccessStatusIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="27"
            height="28"
            viewBox="0 0 27 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx="13.4922" cy="14.0508" r="13.5" fill="#50B061" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.66189 15.3465L11.997 18.7769L11.9985 18.7784C12.12 18.8999 12.3481 19.0129 12.5811 19.0129C12.8075 19.0129 13.0256 18.9037 13.2047 18.8141L13.22 18.8065L13.2438 18.7946L19.5509 12.1052C19.8938 11.7605 19.8932 11.1902 19.5493 10.8463C19.2048 10.5018 18.6332 10.5017 18.2887 10.8463L12.5803 16.8354L9.92499 14.0885L9.92319 14.0868C9.57869 13.7422 9.00718 13.7422 8.66267 14.0868C8.31843 14.431 8.31817 15.0019 8.66189 15.3465ZM12.4075 18.8385C12.282 18.8041 12.1705 18.7382 12.1047 18.6723L8.76889 15.2412C8.48296 14.9553 8.48296 14.4788 8.76889 14.1929C8.96265 13.9991 9.24395 13.9366 9.49414 14.0055C9.24391 13.9366 8.96254 13.999 8.76874 14.1928C8.48282 14.4787 8.48282 14.9553 8.76874 15.2412L12.1045 18.6723C12.1704 18.7382 12.2819 18.8041 12.4075 18.8385ZM12.5811 17.052L18.3948 10.9523C18.5875 10.7597 18.8668 10.6968 19.1159 10.7638C18.8668 10.6969 18.5876 10.7597 18.395 10.9524L12.5812 17.0521L12.5811 17.052Z"
                fill="white"
            />
        </svg>
    );
};
